import { render, staticRenderFns } from "./b_OneTranslationProject.vue?vue&type=template&id=2de18a12&scoped=true&"
import script from "./b_OneTranslationProject.vue?vue&type=script&lang=js&"
export * from "./b_OneTranslationProject.vue?vue&type=script&lang=js&"
import style0 from "./b_OneTranslationProject.vue?vue&type=style&index=0&id=2de18a12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de18a12",
  null
  
)

export default component.exports